const menu = { key: "aiDevelopmentStories", route: "/ai-development/stories", label: "aiDevelopment.title",
  permission: "ai.development.read", icon: "faCode", group: "aiDevelopment", groupLabel: "aiDevelopment.title", order: 10 };
export default menu;
